module.exports = __webpack_public_path__ + "img/Logo.c1e9622a.svg";